import { create } from 'zustand'

import { DashboardResponse } from '@/services/api/dashboard'
import { ExpenseItem } from '@/services/api/expense'
import { IncomeItem } from '@/services/api/income'

interface DashboardStore {
  financialYear: number
  setFinancialYear: (year: number) => void

  navigationOpen: boolean
  setNavigationOpen: (value: boolean) => void

  dashboard?: DashboardResponse
  setDashboard: (data: DashboardResponse) => void

  expenses: ExpenseItem[]
  setExpenses: (expenses: ExpenseItem[]) => void

  incomes: IncomeItem[]
  setIncomes: (incomes: IncomeItem[]) => void
}

export const useDashboardStore = create<DashboardStore>((set) => ({
  financialYear: parseInt(localStorage.getItem('financialYear') || new Date().getFullYear().toString()),
  setFinancialYear: (year: number) => {
    localStorage.setItem('financialYear', year.toString())
    set({ financialYear: year })
  },

  navigationOpen: false,
  setNavigationOpen: (value: boolean) => set({ navigationOpen: value }),

  dashboard: undefined,
  setDashboard: (data: DashboardResponse) => set({ dashboard: data }),

  expenses: [],
  setExpenses: (expenses: ExpenseItem[]) => set({ expenses }),

  incomes: [],
  setIncomes: (incomes: IncomeItem[]) => set({ incomes }),
}))